<script setup lang="ts">
import { inputNumberProps } from 'naive-ui'

const props = defineProps(inputNumberProps)

const slots = defineSlots<{
  prefix: () => any
  suffix: () => any
}>()

const value = defineModel('value', {
  type: null as unknown as PropType<number | null>,
  default: undefined,
})

function format(value: number | null) {
  if (value === null)
    return ''

  const formatter = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: props.precision,
    maximumFractionDigits: props.precision,
    useGrouping: false,
  })

  return formatter.format(value)
}

function parse(input: string) {
  const nums = input.replace(/,/g, '.').trim()
  if (/^-?\d+(?:\.\d*)?$/.test(nums))
    return Number(nums)
  return nums === '' ? null : Number.NaN
}
</script>

<template>
  <NInputNumber
    v-bind="props"
    v-model:value="value"
    :format="format"
    :parse="parse"
  >
    <template v-if="slots.prefix" #prefix>
      <slot name="prefix" />
    </template>
    <template v-if="slots.suffix" #suffix>
      <slot name="suffix" />
    </template>
  </NInputNumber>
</template>
